import { Perm } from "../../Components/Dialogs/helpers";

export const handleAclLists = (res, setACLList, setACLInherited, setPermissionList) => {
  setACLList(res.entries);
  setACLInherited(res.inherited);
  setPermissionList(res.entries ? res.entries.map((entry) => Perm.getLabelList(entry.permissions)) : []);
};
